import css_b03zajrf3cg from './css/OverlayContainer.css';
import Div from './Div.js';
import Overlay from './Overlay.js';

const css = css_b03zajrf3cg;

export default class OverlayContainer extends Div
{
	constructor(parentElement)
	{
		super(parentElement);

		this.overlay = new Overlay(this);
	}

	get cssText()
	{
		return css;
	}
}